import PropTypes from 'prop-types';
import React from 'react';

import StageRunSampleLink from 'workflows/components/StageRunSampleLink';
import {
  STAGE_RUN_FULL_SHAPE,
  STAGE_RUN_SAMPLE_FULL_SHAPE,
  StageRun,
  StageRunSample,
} from 'workflows/WorkflowConstants';

import InputTableContainerCell from './InputTableContainerCell';
import SharedInputTableRow from './SharedInputTableRow';

/**
 * Input table row displaying a sample obtained from an external batch. The row also allows
 * specifying the container to use.
 */

interface ExternalSampleInputTableRowProps {
  checkboxCell: JSX.Element;
  experimentalConditionValueNames: Array<string>;
  inputSampleId: string;
  stageRun: StageRun;
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample};
  locked: boolean;
  viewer?: boolean;
}

class ExternalSampleInputTableRow extends React.Component<ExternalSampleInputTableRowProps> {
  static propTypes = {
    checkboxCell: PropTypes.node.isRequired,
    experimentalConditionValueNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    inputSampleId: PropTypes.string.isRequired,
    stageRun: STAGE_RUN_FULL_SHAPE.isRequired,
    stageRunSampleById: PropTypes.objectOf(STAGE_RUN_SAMPLE_FULL_SHAPE).isRequired,
    locked: PropTypes.bool.isRequired,
    viewer: PropTypes.bool,
  };

  _renderSampleCell(): JSX.Element {
    const {inputSampleId, stageRunSampleById} = this.props;
    return <StageRunSampleLink sample={stageRunSampleById[inputSampleId]} />;
  }

  _renderContainerCell(): JSX.Element {
    return (
      <InputTableContainerCell
        stageRun={this.props.stageRun}
        inputSampleId={this.props.inputSampleId}
        stageRunSampleById={this.props.stageRunSampleById}
        locked={this.props.locked}
        viewer={this.props.viewer}
      />
    );
  }

  render(): JSX.Element {
    return (
      <SharedInputTableRow
        checkboxCell={this.props.checkboxCell}
        experimentalConditionValueNames={this.props.experimentalConditionValueNames}
        sampleCellContents={this._renderSampleCell()}
        containerCellFullElement={this._renderContainerCell()}
        stageRun={this.props.stageRun}
      />
    );
  }
}

export default ExternalSampleInputTableRow;
